import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Navigation from './Navigation';
import { actionCreators } from '../../actionCreators';
import { deepEqual } from '../../utils';
import ToolbarFleetChooser from './../../Fleet/ToolbarFleetChoser';

class Toolbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFleetChooser: false,
    };
    this.signOut = this.signOut.bind(this);
    this.toggleFleetChooser = this.toggleFleetChooser.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !deepEqual(this.state, nextState)
      || !deepEqual(this.props, nextProps);
  }

  signOut() {
    this.props.dispatch(actionCreators.signOut());
  }

  toggleFleetChooser() {
    this.setState({
      showFleetChooser: !this.state.showFleetChooser,
    });
  }

  render() {
    let currentFleetLetter = String(this.props.currentFleet || '?')[0].toUpperCase();
    if (currentFleetLetter === '_') { currentFleetLetter = 'G'; }

    return (
      <div className="toolbar">
        <div className="toolbar-inner">
          <div className="logo">
            <img src="/img/logo.svg" alt="TTRUCK" />
          </div>

          <ul className="top">
            <li>
              <a
                onClick={this.toggleFleetChooser}
                onKeyPress={this.toggleFleetChooser}
                role="link"
                tabIndex="0"
                style={{ fontSize: '22px', fontWeight: 'bold' }}
              >
                {currentFleetLetter}
              </a>
            </li>
          </ul>

          <ToolbarFleetChooser
            show={this.state.showFleetChooser}
            onChoose={this.toggleFleetChooser}
            onClose={this.toggleFleetChooser}
          />

          <Navigation />

          <ul className="bottom">
            <li>
              <a
                onClick={this.signOut}
                onKeyPress={this.signOut}
                role="link"
                tabIndex="0"
              >
                <i className="md-icon">power_settings_new</i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

Toolbar.propTypes = {
  dispatch: PropTypes.func.isRequired,
  currentFleet: PropTypes.string,
};

Toolbar.defaultProps = {
  currentFleet: null,
};

export default connect(store => ({
  currentFleet: store.authState.currentUser.fleet,
}))(Toolbar);



// WEBPACK FOOTER //
// ./src/Shared/Helpers/Toolbar.js